import React from 'react';

import Hero from '../components/contact-us/Hero'
import ContactForm from '../components/contact-us/form'
import ContactInfo from '../components/contact-us/info'

const ContactUs = () => {
  return (
    <div className="">
      <Hero/>
      <ContactForm/>
      <ContactInfo/>
    </div>
  );
};

export default ContactUs;
